import { render, staticRenderFns } from "./ExternalOrderProviderStatus.vue?vue&type=template&id=73f454cc"
import script from "./ExternalOrderProviderStatus.vue?vue&type=script&lang=ts"
export * from "./ExternalOrderProviderStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports